<template>
  <PSNews />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
